angular
    .module('quattro.bmbo.admin.accounts', [
        'quattro.core.hpls_api_1',
        'quattro.bmbo.account.list',
    ])
    .controller('BmboAdminAccountsController', function (api) {

        this.load = function () {
            api
                .single({
                    method: 'account.list',
                })
                .then(this.handleApiResponse.bind(this));
        };

        this.handleApiResponse = function (result) {
            this.list = result.map(function (account) {
                return {account: account};
            });
        };

        this.load();
    });
